<template>
<div>
  <div class="row">
      <template v-if="data_available">
        <div class="col-4">
          <GenericBarChart
            :data="year_data"
            label-field="year"
            contracts-field="contracts"
            amount-field="amount"
            title-x="Año"
          />
        </div>
        <div class="col-4">
          <GenericBarChart
            :data="cpv_data"
            label-field="key"
            contracts-field="contracts"
            amount-field="amount"
            title-x="CPV"
          />
        </div>
        <div class="col-4">
          <GenericBarChart
            :data="contract_type_data"
            label-field="key"
            contracts-field="contracts"
            amount-field="amount"
            title-x="Tipo de contrato"
          />
        </div>
        <div class="col-4">
          <GenericBarChart
            :data="tenders_per_location"
            label-field="key"
            contracts-field="contracts"
            amount-field="amount"
            title-x="Localizacion"
          />
        </div>
        <div class="col-4">
          <GenericBarWithGoals
              :data="top_awarded_parties"
              label-field="key"
              contracts-field="contracts"
              amount-field="amount"
              goal-field="bajaPct"
              title-x="Top 10 adjudicatarias por importe"
            />
        </div>
      </template>
      <template v-else>
        <p>No hay datos disponibles para mostrar los gráficos.</p>
      </template>
  </div>
  <div class="row">
    <div class="col-12 mb-3 text-left">
      <button  class="btn btn-secondary"
        @click="filtersVisibility = !filtersVisibility"
        aria-controls="procurement-filters-collapse"
        :aria-expanded="filtersVisibility ? 'true' : 'false'">
        <i class="fas fa-filter ml-1" ></i>
        <span v-if="!filtersVisibility"> Mostrar filtros</span><span v-else> Ocultar filtros</span>
      <i :class="!filtersVisibility ?'fas fa-angle-down ml-1' : 'fas fa-angle-up ml-1'" ></i>
      </button>
        <b-collapse v-model="filtersVisibility" class="collapse-tags" id="procurement-filters-collapse">
          <div class="stripe-light  p-3 border">
          <input type="text" class="form-control"
            id="search" placeholder="Filtrar por texto"
            v-model="searchTerms" @keyup.enter="getProcurementPartyContractedProjects()" v-debounce:500ms="getContractedProjectsDebounceSTerms">
          <procurement-filters
            ref="procurement_filters"
            v-on:setFilters="setFilters($event)"
            v-on:yearsChanged="filterYearsChanged($event)"
            :excludedFilters="['contracting_party']"/>
          </div>
        </b-collapse>
      </div>
    </div>
    <div class="row">
      <div class="col-6 text-left">
        <paginationComponent
        id="procurement-pagination"
        :currentPage="current_page"
        :totalPages="total_pages"
        v-on:next-page-procurement-pagination="changePage($event)"/>
      </div>
      <div class="col-6 text-left">
        <!-- btn excel -->
      </div>
    </div>
    <div class ="row">
      <div class="col-12">
        <div v-if="contractedProjectYears.length > 0">
          Mostrando los años {{ contractedProjectYears.join(", ") }}
        </div>
        <procurementResultsTable :projects="contracted_projects"/>
      </div>
      <div class="col-12 text-left">
        <paginationComponent
          id="procurement-pagination"
          :currentPage="current_page"
          :totalPages="total_pages"
          v-on:next-page-procurement-pagination="changePage($event)"/>
      </div>
  </div>
</div>
</template>

<script>
import Vue from 'vue';
import procurementService from '@/_services/procurement.service';
import paginationComponent from '@/components/helpers/pagination.vue';
import GenericBarChart from '@/components/helpers/generic_bar_chart.vue';
import GenericBarWithGoals from '@/components/helpers/generic_bar_goals_chart.vue';

import procurementChartsMixin from '@/_mixins/procurement_charts.mixin';
import procurementMixin from '@/_mixins/procurement.mixin';

import procurementResultsTable from './results_table.vue';
import procurementFilters from './procurement_filters.vue';

export default {
  name: 'procurementPartyContractedProyectsComponent',
  mixins: [procurementMixin, procurementChartsMixin],
  props: ['party'],
  components: {
    GenericBarChart,
    GenericBarWithGoals,
    paginationComponent,
    procurementFilters,
    procurementResultsTable,
  },
  data() {
    return {
      filtersVisibility: false,
      contracted_projects: [],
      projects_stats: {},
      current_page: 1,
      total_results: 0,
      total_pages: 0,
      contractedProjectYears: [],
      searchTerms: '',
      currentFilters: {},
    };
  },
  mounted() {
    this.getProcurementPartyContractedProjects();
  },
  computed: {
  },
  methods: {
    filterYearsChanged(years) {
      const yearsToAdd = years.filter(value => !this.contractedProjectYears.includes(value));
      const yearsToRemove = this.contractedProjectYears.filter(value => !years.includes(value));
      const yearsToToggle = yearsToAdd.concat(yearsToRemove);

      const year_indexes = [];
      yearsToToggle.map((year) => {
        const index = this.chartConfig.options.labels.findIndex(label => label === year);
        if (index >= 0) {
          year_indexes.push(index);
        }
        return index;
      });

      for (let i = 0; i < year_indexes.length; i += 1) {
        this.$refs.apexchart.toggleDataPointSelection(0, year_indexes[i]);
      }
    },
    addYear(year, fromUserClick = true) {
      const index = this.contractedProjectYears.findIndex(el => el === year);
      if (index > -1) {
        // Already there, remove
        this.contractedProjectYears.splice(index, 1);
      } else {
        this.contractedProjectYears.push(year);
      }

      if (fromUserClick) {
        this.$refs.procurement_filters.setDateYears(this.contractedProjectYears);
      }
    },
    changePage(page) {
      this.getProcurementPartyContractedProjects(page);
    },
    getContractedProjectsDebounceSTerms() {
      this.getProcurementPartyContractedProjects();
    },
    getProcurementPartyContractedProjects(page = 1) {
      const params = {
        page,
        years: this.contractedProjectYears,
      };

      if (Object.keys(this.currentFilters).length > 0) {
        params.filters = this.currentFilters;
      }

      if (this.searchTerms !== '') {
        params.searchTerms = this.searchTerms;
      }


      const self = this;
      procurementService.getProcurementPartyContractedProjects(this.$route.params.id, params).then((res) => {
        const { results, aggs } = res.data;
        const { total_results, total_pages, current_page } = res.data.metadata;

        Vue.set(self, 'contracted_projects', results);
        if (current_page === 1 && aggs) {
          Vue.set(self, 'projects_stats', aggs);
        }
        self.total_results = total_results;
        self.total_pages = total_pages;
        self.current_page = current_page;
      });
    },
    setFilters(event) {
      Vue.set(this, 'currentFilters', event.filters);
      this.getProcurementPartyContractedProjects();
    },
  },
};
</script>

<style scoped>
.party{
  padding: 30px;
}
h1{
  display:inline-block;
  margin-left: 5px;
}
.fa-external-link-alt {
  color:#000000;
}
.fa-external-link-alt:hover {
  cursor:pointer;
  color:#4953CF;
}
</style>
